module.exports = __webpack_public_path__ + "img/butterfly-pink.6caca5ab.svg";